import React from "react";

export default function Footer() {
  const root = /(^|\.)bookishcircle\.com$/.test(window.location.hostname) && !["bookishcircle.com", "www.bookishcircle.com"].includes(window.location.hostname) ? "https://bookishcircle.com" : "";
  const columns = [
    [["Browse books", root + "/market"], ["Lady Liza", root + "/lady-liza"], ["Contact Bookish Circle", "mailto:author@hayleyraejohnson.com"]],
    [["For readers", root + "/readerlanding"], ["For authors", root + "/authors"], ["For publishing groups", root + "/publishing-groups"]],
    [["Our story", root + "/about"], ["Privacy Policy", root + "/privacy"], ["Terms", root + "/terms"]],
  ];
  return (
    <footer className="public-footer">
      <div className="public-container">
        <div className="public-footer-top">
          <div>
            <a className="public-brand" href={root + "/"}>The Bookish Circle</a>
            <p>Independent voices. Stories worth finding.</p>
          </div>
          <nav aria-label="Footer navigation">
            {columns.map(column => (
              <ul key={column[0][0]}>
                {column.map(([label, href]) => <li key={label}><a href={href}>{label}</a></li>)}
              </ul>
            ))}
          </nav>
        </div>
        <div className="public-footer-bottom">
          <p className="public-copyright">© {new Date().getFullYear()} The Bookish Circle. All rights reserved.</p>
          <a href={root + "/admin/login"}>Admin login</a>
        </div>
      </div>
    </footer>
  );
}